import { writeSliceModel, upsertGlobalTypeScriptTypes, writeSliceFile } from "@prismicio/plugin-kit/fs";
import { checkIsTypeScriptProject } from "../lib/checkIsTypeScriptProject.js";
import { getSvelteMajor } from "../lib/getSvelteMajor.js";
import { rejectIfNecessary } from "../lib/rejectIfNecessary.js";
import { upsertSliceLibraryIndexFile } from "../lib/upsertSliceLibraryIndexFile.js";
import { sliceTemplate } from "./slice-create.templates.js";
const createComponentFile = async ({ data, helpers, actions, options }) => {
  const { model, componentContents } = data;
  const typescript = await checkIsTypeScriptProject({ helpers, options });
  const contents = componentContents ?? sliceTemplate({ model, typescript, version: await getSvelteMajor() });
  await writeSliceFile({
    libraryID: data.libraryID,
    model: data.model,
    filename: "index.svelte",
    contents,
    format: options.format,
    actions,
    helpers,
    formatOptions: {
      prettier: {
        plugins: ["prettier-plugin-svelte"],
        parser: "svelte"
      }
    }
  });
};
const sliceCreate = async (data, context) => {
  rejectIfNecessary(await Promise.allSettled([
    writeSliceModel({
      libraryID: data.libraryID,
      model: data.model,
      format: context.options.format,
      helpers: context.helpers
    }),
    createComponentFile({ data, ...context })
  ]));
  rejectIfNecessary(await Promise.allSettled([
    upsertSliceLibraryIndexFile({
      libraryID: data.libraryID,
      ...context
    }),
    upsertGlobalTypeScriptTypes({
      filename: context.options.generatedTypesFilePath,
      format: context.options.format,
      helpers: context.helpers,
      actions: context.actions
    })
  ]));
};
export {
  sliceCreate
};
//# sourceMappingURL=slice-create.js.map
